<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-07 15:19:43
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-07 15:33:25
 -->
<template>
  <div class="intruduce">
    <div class="title">车型监测识别一体机</div>
    <div class="describe">专业治超不松懈，守住安全的底线</div>
    <div class="characteristicStatistics">
      <div class="item">
        <div class="insideItem">
          <div class="value">>99%</div>
          <div class="label">车辆捕获率</div>
        </div>
      </div>
      <div class="item">
        <div class="insideItem">
          <div class="value">>98%</div>
          <div class="label">车牌识别正确率</div>
        </div>
      </div>
      <div class="item">
        <div class="insideItem">
          <div class="value">>98%</div>
          <div class="label">车型识别率</div>
        </div>
      </div>
    </div>
    <div class="content">
      用于出入口治超车道的车型检测与识别，满足交通部<span>《高速公路称重检测业务规范和技术要求》</span>，具备<span>高清图像抓拍、视频取证、车型及车牌识别</span>等功能。为高速公路违法超限超载治理提供清晰完整的图像监测数据。
    </div>
  </div>
</template>

<script>
export default {
  name: 'intruduce',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .intruduce {
    width: 100%;
    height: 100%;
    .title {
      font-size: 30px;
      color: rgb(236, 235, 80);
      font-weight: bold;
      text-align: center;
      margin-bottom: 25px;
    }
    .describe {
      font-size: 26px;
      color: rgb(16, 186, 186);
      text-align: center;
    }
    .characteristicStatistics {
      width: 60%;
      margin: 30px 20%;
      height: 57px;
      display: flex;
      justify-content: space-between;
      .item {
        display: inline-block;
        width: 189px;
        height: 100%;
        background: linear-gradient(to left, #9ceff1, #9ceff1) left top no-repeat,
                    linear-gradient(to bottom, #9ceff1, #9ceff1) left top no-repeat,
                    linear-gradient(to left, #9ceff1, #9ceff1) right top no-repeat,
                    linear-gradient(to bottom, #9ceff1, #9ceff1) right top no-repeat,
                    linear-gradient(to left, #9ceff1, #9ceff1) left bottom no-repeat,
                    linear-gradient(to bottom, #9ceff1, #9ceff1) left bottom no-repeat,
                    linear-gradient(to left, #9ceff1, #9ceff1) right bottom no-repeat,
                    linear-gradient(to left, #9ceff1, #9ceff1) right bottom no-repeat;
        background-size: 2px 20px, 20px 2px, 2px 20px, 20px 2px;
        .insideItem {
          width: 100%;
          height: 100%;
          background: rgba(20, 76, 89, 0.4);
          .value {
            text-align: center;
            color: #fff;
            font-size: 18px;
            line-height: 34px;
            font-weight: bold;
          }
          .label {
            text-align: center;
            color: rgb(9, 236, 255);
            font-size: 14px;
          }
        }
      }
    }
    .content {
      font-size: 20px;
      color: #05dbe3;
      line-height: 30px;
      display: inline-block;
      width: 80%;
      margin-left: 10%;
      text-indent: 40px;
      margin-top: 20px;
      >span:nth-of-type(1) {
        font-weight: bold;
      }
      >span:nth-of-type(2) {
        font-weight: bold;
        color: rgb(236, 235, 80);
      }
    }
  }
</style>
